import React, { useContext } from "react";

import { makeStyles } from "tss-react/mui";

import { RetroLayout } from "components/retrospective/RetroLayout";
import { RetroCard } from "components/retrospective/RetroCard";
import { Grid, Typography } from "@mui/material";
import { VictoryPie } from "victory";
import { RetroContext } from "components/retrospective/RetrospectiveMain";

const PAGE_DATA = {
  title: "Energia Verde",
  subtitle: "Fonte de energia limpa e eficiente",
  bgGradient: "#F8B229",
  illustrationSrc: "/static/img/retro2025/energyImg.png",
  bgImage: "/static/img/retro2025/energy.jpg",
  pageNum: "2",
};

const useStyles = makeStyles()((theme) => ({
  data: {
    display: "grid",
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    height: "100%",
    position: "relative",

    // vertical
    gridTemplateRows: "repeat(4, 1fr)",
    gridTemplateColumns: "100%",

    // horizontal
    "@media (orientation: landscape)": {
      gridTemplateRows: "repeat(5, 1fr)",
      gridTemplateColumns: "50% 50%",
    },
  },
  chart: {
    position: "relative",
    gridRow: "span 3",
    gridColumn: "span 1",

    // horizontal
    "@media (orientation: landscape)": {
      gridRow: "1/ span 4",
      gridColumn: "span 1",
    },
  },
  chartCaption: {
    position: "absolute",
    top: "calc(50% - 50px)",
    left: "calc(50% - 50px)",
    width: "100px",
    height: "100px",
  },
}));

export const RetroEnergy = () => {
  const { classes } = useStyles();

  const { totalConsumoSomatorio, percentualEnergiaVerde } =
    useContext(RetroContext);

  return (
    <RetroLayout {...PAGE_DATA}>
      <Grid item container className={classes.data}>
        <Grid className={classes.chart}>
          <VictoryPie
            data={[
              { x: "solar", y: percentualEnergiaVerde, fill: "#FCD34D" },
              {
                x: "outros",
                // @ts-expect-error
                y: 100 - (percentualEnergiaVerde || 0),
                fill: "#4B5563",
              },
            ]}
            innerRadius={100}
            labels={[]}
            style={{
              data: {
                stroke: "#fff",
                fill: ({ datum }) => datum.fill,
              },
            }}
          />
          <Grid
            item
            container
            direction="column"
            className={classes.chartCaption}
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              color="common.white"
              variant="h1"
              component="span"
              sx={{ m: 0 }}
            >{`${percentualEnergiaVerde?.toLocaleString(
              "pt-br"
            )}%`}</Typography>
          </Grid>
        </Grid>
        <RetroCard
          variant="dark"
          mainInfo={totalConsumoSomatorio?.toLocaleString("pt-br") || "-"}
          mainSuffix="kWh"
          caption="Energia consumida"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="2 / span 2"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
      </Grid>
    </RetroLayout>
  );
};
